<template>
	<div>
		<h1 class="heading">{{msg}}</h1>
	</div>
</template>

<script>
export default {
  name: 'Heading',
  props: ['msg'],
}
</script>

<style scoped>
</style>
